module.exports = __webpack_public_path__ + "static/media/mom3.4d1329c2.jpg";